import { Button, ButtonVariant, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import React from "react";

import Trans from "@/components/Trans/Trans";

type DiscoverRowErrorProps = {
  onRetry: () => void;
};

const DiscoverRowError = ({ onRetry }: DiscoverRowErrorProps) => {
  return (
    <div data-testid="DiscoverRowError" className="flex flex-col items-start gap-3 py-4">
      <Text variant={TextVariants.LABEL_LARGE_REGULAR}>
        <Trans i18nKey="error:title.somethingWentWrong" />
      </Text>
      <Button data-testid="DiscoverRowError-RetryButton" type="button" variant={ButtonVariant.CONTAINED} onClick={onRetry}>
        <Trans i18nKey="error:cta.tryAgain" />
      </Button>
    </div>
  );
};

export default React.memo(DiscoverRowError);
